import type { SettingsMenuContainer } from '../settings-menu-container'

import { li, span } from '|>/shared/h'
import { register } from '|>/shared/vjs'
import { BaseMenuItem } from '../../base'
import { LocalEvents } from '../local-events'

/**
 * Subtitles custom menu item in settings subtitles menu
 */
@register
export class SettingsSubtitlesCustomItem extends BaseMenuItem {
  declare options_: any
  declare container: SettingsMenuContainer | undefined

  declare labelEl_: HTMLSpanElement

  override createEl() {
    return li('.vjs-menu-item.vjs-x-menu-subtitles-nested-item', [
      (this.labelEl_ = span(
        '.vjs-menu-item-text',
        this.localize(this.options_.label)
      )),
      span('.vjs-icon-placeholder', { ariaHidden: 'true' }),
    ])
  }

  override handleClick() {
    this.container?.trigger(LocalEvents.SettingsActivateSubtitlesCustomMenu)
  }
}

SettingsSubtitlesCustomItem.options = {
  label: 'custom_setting',
}
